import { Notifier } from "@airbrake/browser";

if (window.env.JEKYLL_ENV === "production") {
  try {
    window.airbrake = new Notifier({
      projectId: window.env.AIRBRAKE_PROJECT_ID,
      projectKey: window.env.AIRBRAKE_PROJECT_KEY,
      host: "https://panel.sutty.nl",
    });

    console.originalError = console.error;
    console.error = (...e) => {
      window.airbrake.notify(e.join(" "));
      return console.originalError(...e);
    };
  } catch (e) {
    console.error(e);
  }
}

import * as Turbo from "@hotwired/turbo";
Turbo.start();

import { Application } from "@hotwired/stimulus";
window.Stimulus = Application.start();

import ContactController from "./controllers/contact_controller";
import PrintController from "./controllers/print_controller";
import ShareController from "./controllers/share_controller";

Stimulus.debug = window.env.JEKYLL_ENV !== "production";
Stimulus.register("contact", ContactController);
Stimulus.register("print", PrintController);
Stimulus.register("share", ShareController);
